import { render, staticRenderFns } from "./HomeWantBuy.vue?vue&type=template&id=97261dda&scoped=true&"
import script from "./HomeWantBuy.vue?vue&type=script&lang=js&"
export * from "./HomeWantBuy.vue?vue&type=script&lang=js&"
import style0 from "./HomeWantBuy.vue?vue&type=style&index=0&id=97261dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97261dda",
  null
  
)

export default component.exports